import Map from "./Map";

class MapRadius extends Map {
    constructor(elem, locations) {
        super(elem, locations, 10);

        this._setDOMReferences();
    }

    _setDOMReferences() {}

    createMarker(location, type, icon, obj) {
        const marker = new window.google.maps.Marker({
            map: this.map,
            position: location,
            icon: icon
        });

        const radius = obj.radius ? obj.radius : 0;

        const circle = new google.maps.Circle({
            map: this.map,
            strokeColor: "#009FE3",
            strokeOpacity: 0.4,
            strokeWeight: 2,
            fillColor: "#0070B8",
            fillOpacity: 0.1,
            radius: radius * 1000
        });
        circle.bindTo("center", marker, "position");

        this.markers[type].push(marker);

        this.bounds.extend(location);
    }

    mapFitBounds() {
        // FITBOUNDS WHEN MORE THAN 1 MARKERS
        if (this.locations.length > 1) {
            //this.map.fitBounds(this.bounds);
            this.map.panToBounds(this.bounds);
        }
    }
}

export default MapRadius;
